import { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '@/components/layout/Sidebar';
import Topbar from '@/components/layout/Topbar';
import ChatWidget from '@/components/ChatWidget';
import GuideModal from '@/components/GuideModal';

/**
 * AppLayout - Customer-facing dashboard shell
 * 
 * RESPONSIBILITIES:
 * - Sidebar navigation
 * - Topbar with business selector + SMS balance + user menu
 * - Page container framing
 * 
 * DOES NOT:
 * - Fetch data (receives via props/context)
 * - Contain business logic
 * - Make API calls
 * - Handle auth (that's AuthLayout's job)
 */
export default function AppLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  // Close sidebar on route change (mobile)
  useEffect(() => {
    setSidebarOpen(false);
  }, [window.location.pathname]);

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Sidebar */}
      <Sidebar 
        isOpen={sidebarOpen} 
        onClose={() => setSidebarOpen(false)}
      />

      {/* Main content area */}
      <div className="lg:pl-64">
        {/* Topbar */}
        <Topbar onMenuClick={() => setSidebarOpen(true)} />
        
        {/* Page content */}
        <main className="pt-16">
          <Outlet />
        </main>
      </div>
      <ChatWidget />
      <GuideModal />
    </div>
  );
}
